import ReactWrapper from './ReactWrapper';

/**
 * Mounts and renders a react component into the document and provides a testing wrapper around it.
 *
 * @param node
 * @returns {ReactWrapper}
 */
export default function mount(node, options) {
  return new ReactWrapper(node, null, options);
}
